export default __webpack_public_path__ + "static/media/sykes.e3c79489.pdf";